//  Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Popover, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { translate } from 'react-i18next';

const classPrefix = 'create-group';

export class CreateGroupPopover extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            groupName: '',
            touched: {
                groupName: false
            }
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSubmit() {
        const groupName = this.state.groupName;
        this.refs.enterGroupName.hide();
        return this.props.groupData(groupName);
    }

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            const errors = this.validateInput(this.state.groupName);
            errors.groupName === false ? this.handleSubmit() : null;
        }
        this.setState({
            touched: { ...this.state.touched, groupName: true },
        });
    }

    validateInput(groupName) {
        return {
            groupName: (groupName.trim().length === 0) || (groupName.toLowerCase().trim() === 'general')
        };
    }

    showCreateGroupPopover() {
        const {t} = this.props;
        const {groupName} = this.state;
        const errors = this.validateInput(groupName);
        const isDisabled = Object.keys(errors).some(x => errors[x]);

        const shouldMarkError = (field) => {
            const hasError = errors[field];
            const shouldShow = this.state.touched[field];
            return hasError ? shouldShow : false;
        };

        return (
            <Popover id="popover-positioned-bottom" className={`${classPrefix}-popover`}>
                <span className={`${classPrefix}-popover_title`}>{t('groups.popover-text')}</span>
                <div className={`${classPrefix}-popover_body`}>
                    <input
                      type="text"
                      name="groupName"
                      placeholder="Enter Group Name"
                      className={`form-control ${shouldMarkError('groupName') ? 'input-error' : ''}`}
                      value={this.state.groupName}
                      onChange={this.handleInputChange}
                      maxLength="50"
                      onKeyPress={this.handleKeyPress.bind(this)}
                    />
                    <div className={`${classPrefix}-popover_button`}>
                        <Button disabled={isDisabled} onClick={this.handleSubmit.bind(this)}>{t('button.save')}</Button>
                    </div>
                </div>
                <span className={shouldMarkError('groupName') ? 'group-name-err-msg' : 'hide'}>{t('groups.errors.inline-group-error')}</span>
            </Popover>
      );
    }

    render() {
        const {t} = this.props;
        const createNewGroupTooltip = (<Tooltip className={`${classPrefix}-icon-tooltip`} id="createNewGroupTooltip"><strong>{t('groups.tooltip')}</strong></Tooltip>);
        return (
            <div className={`${classPrefix}`}>
                <hr className={`${classPrefix}_hr`}></hr>
                <OverlayTrigger
                  ref="enterGroupName"
                  placement="bottom"
                  overlay={this.showCreateGroupPopover()}
                  trigger="click"
                  rootClose={true}
                  onEnter={() => this.refs.GroupTooltip.hide()}
                  onExited={() => { this.setState({groupName: '', touched: {groupName: false}}); }}
                >
                    <OverlayTrigger ref="GroupTooltip" placement="bottom" overlay={createNewGroupTooltip} trigger={['hover', 'focus']}>
                        <span className={`${classPrefix}_addIcon`}>
                            <i className="togo-icon togo-icon-add"></i>
                        </span>
                    </OverlayTrigger>
                </OverlayTrigger>
            </div>
          );
    }
}

CreateGroupPopover.propTypes = {
    t: PropTypes.func,
    groupData: PropTypes.func
};

export default translate(['translation'])(CreateGroupPopover);



// WEBPACK FOOTER //
// ./src/components/catalog/group/create-group-popover.js